<template>
  <div class="set-password">
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title word-type pb-5">
        <icon-lock :width="24" :height="24" />비밀번호 변경
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="12" class="info-txt">
        새로운 비밀번호를 만들어 주세요.<br />
        * 8자리 이상 영문,숫자, 특수기호 조합 필수
      </v-col>
    </v-row>

    <v-form>
      <v-row class="mx-0 mb-0 form-wrap overflow-y-auto">
        <!-- 현재 비밀번호 -->
        <v-col cols="12" class="py-0 px-6 input-wrap">
          <v-text-field
            v-model="password"
            ref="password"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required]"
            :type="show ? 'text' : 'password'"
            name="password"
            placeholder="현재 비밀번호를 입력해주세요."
            outlined
            dense
            solo
            class="shadow-none"
            @click:append="show = !show"
          ></v-text-field>
        </v-col>

        <!-- 변경 비밀번호 -->
        <v-col cols="12" class="py-0 px-6">
          <v-text-field
            v-model="newPassword"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.valid]"
            :type="show1 ? 'text' : 'password'"
            name="newPassword"
            placeholder="새로운 비밀번호를 입력해주세요."
            outlined
            dense
            solo
            class="shadow-none"
            @click:append="show1 = !show1"
          ></v-text-field>
        </v-col>

        <!-- 변경 비밀번호 확인 -->
        <v-col cols="12" class="py-0 px-6">
          <v-text-field
            v-model="newPasswordChk"
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.checked]"
            :type="show2 ? 'text' : 'password'"
            name="newPasswordChk"
            placeholder="새로운 비밀번호를 재입력해주세요."
            outlined
            dense
            solo
            class="shadow-none"
            @click:append="show2 = !show2"
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- 로그인 버튼 고정 -->
      <v-bottom-navigation
        fixed
        scroll-threshold="500"
        height="96"
        style="box-shadow: none"
      >
        <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
          <v-col cols="12">
            <v-btn
              block
              elevation="0"
              class="btn-fixed"
              color="darkGrey"
              @click="changePassword()"
            >
              <span class="white--text">변경하기</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-bottom-navigation>
    </v-form>
  </div>
</template>

<script>
/* 비밀번호변경(설정) */
import IconLock from '@/assets/customIcon/IconLock.vue';
import { setRSA } from '@/utils/rsa/rsaUtil';
import { getAuthRSA, checkUserNoRsa, changePassword } from '@/api/auth';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      password: '', // 현재 비밀번호
      newPassword: '', // 변경 비밀번호
      newPasswordChk: '', // 변경 비밀번호 확인

      sessionKey: '',
      rsaData: {},

      rules: {
        required: value => !!value || '비밀번호를 입력해주세요.',
        checked: v =>
          this.newPassword === v || '새 비밀번호가 일치하지 않습니다.',
        valid: v =>
          /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/.test(
            v,
          ) ||
          '비밀번호는 8자리 이상의 영문, 숫자, 특수 기호로 구성되어야 합니다.',
      },

      show: false,
      show1: false,
      show2: false,
    };
  },

  computed: {
    ...mapGetters(['GET_USER_DATA']),
  },

  methods: {
    changePassword() {
      if (!this.checkPasswordData()) {
        return;
      }

      if (confirm('비밀번호를 변경하시겠습니까?')) {
        this.fetchRSAData();
      }
    },

    /* 비밀번호 입력데이터 확인 */
    checkPasswordData() {
      // 1. 필수값 입력확인
      if (this.password === '') {
        alert('현재 비밀번호를 입력해주세요.');
        return false;
      }

      if (this.newPassword === '') {
        alert('변경 비밀번호를 입력해주세요.');
        return false;
      }

      if (this.newPasswordChk === '') {
        alert('변경 비밀번호를 재입력해주세요.');
        return false;
      }

      // 2. 변경비밀번호 일치확인
      if (this.newPassword !== this.newPasswordChk) {
        alert('변경 비밀번호가 일치하지 않습니다.');
        return false;
      }

      // 3. 비밀번호 유효성검사
      const regex =
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/;

      if (!regex.test(this.newPassword)) {
        alert(
          '비밀번호는 8자리 이상의 영문, 숫자, 특수 기호로 구성되어야 합니다.',
        );
        return false;
      }

      return true;
    },

    /* Auth RSA 암호키 호출 */
    async fetchRSAData() {
      try {
        // 0. Res Data Setting
        const response = await getAuthRSA();
        const result = response.data;

        if (result.message === 'OK') {
          this.sessionKey = result.data.sessionKey;
          const rsaModulus = result.data.RSAModulus;
          const rsaExponent = result.data.RSAExponent;

          // rsa setting
          this.rsaData = setRSA(
            { rsaModulus, rsaExponent },
            this.GET_USER_DATA.id,
            this.password,
            this.newPassword,
          );

          this.fetchUserCheck();
        }
      } catch (error) {
        console.log(error);
      }
    },

    /* 사용자체크 */
    async fetchUserCheck() {
      try {
        const response = await checkUserNoRsa({
          id: this.rsaData.uIdRsa,
          pswd: this.rsaData.pwdRsa,
          sessionKey: this.sessionKey,
          tenantKey: this.GET_USER_DATA.tenantKey,
          deleteRsaKey: 'Y',
        });
        const userData = response.data.data.result;

        if (userData.message === 'EXIST') {
          const userKey = userData.userKey;
          this.fetchPasswordChange(userKey);
        } else {
          alert('현재 비밀번호가 일치하지 않습니다.');
          this.$refs.password.focus();
        }
      } catch (error) {
        console.log(error);
      }
    },

    /* 비밀번호 변경 */
    async fetchPasswordChange(userKey) {
      try {
        const paramObj = {
          userKey: userKey,
          newPassword: this.rsaData.newPwdRsa,
          sessionKey: this.sessionKey,
          tenantKey: this.GET_USER_DATA.tenantKey,
        };
        const response = await changePassword(paramObj);
        const resultData = response.data.data;

        if (resultData.msg === 'OK') {
          alert('비밀번호가 변경되었습니다.');
          this.$router.push('/main');
        } else {
          alert(resultData.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },

  components: {
    IconLock,
  },
};
</script>

<style>
/* setPassword.scss 참고 */
</style>
